import mitt from 'mitt';
import ErrorBanner from './ErrorBanner';

export const createErrorBannerGlobal = (Vue, globalOptions = {}) => {
    let vm;

    const emitter = mitt();

    Vue.prototype.$errorBannerEmitter = emitter;

    return (options) => {
        const { selector, topPxOffset, useErrorBannerContainer } = globalOptions;
        const { messages } = Vue.prototype.$designSystem.i18n;

        if (useErrorBannerContainer) {
            emitter.emit('open', options);

            return null;
        }

        const hasErrorBannerSelector = selector && document.querySelector(selector);
        const container = hasErrorBannerSelector
            ? document.querySelector(selector)
            : document.body;

        const cleanup = () => {
            container.removeChild(vm.$el);
            vm.$destroy();
            vm = null;

            if (Vue.prototype.$bus) {
                Vue.prototype.$bus.$off('CLOSE_ERROR_BANNER');
            }
        };

        if (vm) {
            cleanup();
        }

        const isOverlayActive = document.body.className.indexOf('overlay-active') >= 0;

        const ErrorBannerClone = Vue.extend(ErrorBanner);

        vm = new ErrorBannerClone({
            propsData: {
                isOpen: true,
                position: options.bottom || isOverlayActive ? 'bottom' : 'top',
                message: options.message,
                showIcon: options.showIcon,
                critical: options.critical,
                actionLabel: options.actionText,
                closeLabel: options.closeLabel || messages['errorbanner.dismiss'],
            },
        }).$mount();

        vm.$on('close', () => {
            cleanup();
        });

        if (options.action && typeof options.action === 'function') {
            vm.$on('action', () => {
                options.action();
                cleanup();
            });
        }

        if (Vue.prototype.$bus) {
            Vue.prototype.$bus.$on('CLOSE_ERROR_BANNER', cleanup);
        }

        container.prepend(vm.$el);

        if (topPxOffset) {
            vm.$el.style.top = typeof topPxOffset === 'function' ? topPxOffset() : topPxOffset;
        }

        return vm;
    };
};
